export function caruselImages() {
    const sections = document.querySelectorAll('.l-section-carousel');
    if (!sections.length) return;

    sections.forEach(section => {
      const swiperEl = section.querySelector('.swiper-container');
      const nextBtn  = section.querySelector('#next-swiper');
      const prevBtn  = section.querySelector('#prev-swiper');
      const container = section.querySelector('.container'); // контейнер, який треба стилізувати

      if (!swiperEl || !nextBtn || !prevBtn || !container) return;

      const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
      const viewportW  = window.innerWidth;

      // Умова: ≤4 слайди + десктоп
      if (slideCount <= 4 && viewportW >= 1024) {
        // сховаємо кнопки
        nextBtn.style.display = 'none';
        prevBtn.style.display = 'none';
        // додамо клас, щоб через CSS можна було змінити стилі
        section.classList.add('no-swiper-init');
        container.classList.add('no-swiper-container');
        return;
      }

      // Інакше — ініціалізуємо Swiper
      prevBtn.style.display = 'none';
      const swiper = new Swiper(swiperEl, {
        loop: false,
        roundLengths: true,
        slidesPerView: 4.5,
        spaceBetween: 4,
        breakpoints: {
          320:  { slidesPerView: 1.35, spaceBetween: 4 },
          764:  { slidesPerView: 2.45, spaceBetween: 4 },
          1024: { slidesPerView: 3.5,  spaceBetween: 4 },
          1200: { slidesPerView: 4.5,  spaceBetween: 4 },
        },
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn
        },
        on: {
          init:       swiper => updatePrevButton(swiper),
          slideChange: swiper => updatePrevButton(swiper)
        }
      });

      function updatePrevButton(sw) {
        prevBtn.style.display = sw.isBeginning ? 'none' : '';
      }
    });
  }
